import { p60Constants } from '../constants';

const initialState = {
  loading: false,
  records: []
}

export function p60(state = initialState, action) {
  switch (action.type) {
    case p60Constants.GET_REQUEST:
      return {
        loading: true,
        records: [],
      };
    case p60Constants.GET_SUCCESS:
      console.log(action.payload);
      return {
        loading: false,
        records: action.payload,
      };
    case p60Constants.GET_FAILURE:
      return {
        loading: false,
        error: action.error,
        records: [],
      };
    default:
      return state
  }
}
